export default __webpack_public_path__ + "static/1-map-b20ad986c782056c63defcc47653758e.jpg";